import { NgModule } from '@angular/core';
import { FiUpgradeCountdownNotificationService } from './upgrade-countdown-notification.service';

@NgModule({
    providers: [FiUpgradeCountdownNotificationService],
})
export class FiUpgradeCountdownNotificationModule {}
